module.exports = __webpack_public_path__ + "components/country-flag/static/bg-6b9a6258fad755584b0eae93659a5749.svg";